/**
 * Alinha login ao backend: minúsculas e sem qualquer espaço em branco.
 */
export function normalizeNmLogin(value) {
  if (value == null || typeof value !== "string") return "";
  return value.replace(/\s+/g, "").toLowerCase();
}
